var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        title: _vm.isView
          ? "查看进口商"
          : _vm.rowData?.id
          ? "修改进口商"
          : "新增进口商",
        visible: _vm.dialogVisible,
        width: "1150px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "top",
                disabled: _vm.isView,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 17 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "进口商名称", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.form.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status",
                              },
                            },
                            _vm._l(
                              _vm.config.importerStatusOptions,
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "EIN NO", prop: "taxNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入",
                              maxlength: "12",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.taxNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "taxNo", $$v)
                              },
                              expression: "form.taxNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "法人", prop: "contact" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.contact,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "contact", $$v)
                          },
                          expression: "form.contact",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "BOND Number", prop: "bondNumber" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.bondNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bondNumber", $$v)
                          },
                          expression: "form.bondNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "BOND额度", prop: "bondTotal" } },
                    [
                      _c("NumberPoint", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.bondTotal,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bondTotal", $$v)
                          },
                          expression: "form.bondTotal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "归属", prop: "belong" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.handleBelongChange },
                          model: {
                            value: _vm.form.belong,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "belong", $$v)
                            },
                            expression: "form.belong",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("内部"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("外部"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Surety Code", prop: "suretyCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.form.suretyCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "suretyCode", $$v)
                            },
                            expression: "form.suretyCode",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "054", value: "054" },
                          }),
                          _c("el-option", {
                            attrs: { label: "856", value: "856" },
                          }),
                          _c("el-option", {
                            attrs: { label: "036", value: "036" },
                          }),
                          _c("el-option", {
                            attrs: { label: "300", value: "300" },
                          }),
                          _c("el-option", {
                            attrs: { label: "846", value: "846" },
                          }),
                          _c("el-option", {
                            attrs: { label: "873", value: "873" },
                          }),
                          _c("el-option", {
                            attrs: { label: "128", value: "128" },
                          }),
                          _c("el-option", {
                            attrs: { label: "664", value: "664" },
                          }),
                          _c("el-option", {
                            attrs: { label: "353", value: "353" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "买BOND代理", prop: "bondSupplierId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.bondSupplierId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "bondSupplierId", $$v)
                            },
                            expression: "form.bondSupplierId",
                          },
                        },
                        _vm._l(_vm.supplierOptions, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.code + "-" + item.wbName,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "年审截止时间",
                        prop: "yearAuditDeadlineDate",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "date",
                          align: "center",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.yearAuditDeadlineDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "yearAuditDeadlineDate", $$v)
                          },
                          expression: "form.yearAuditDeadlineDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "报税截止时间",
                        prop: "bondedDeadlineDate",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "280px" },
                        attrs: {
                          type: "date",
                          align: "center",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.bondedDeadlineDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bondedDeadlineDate", $$v)
                          },
                          expression: "form.bondedDeadlineDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "注册时间", prop: "registerDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "date",
                          align: "center",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.registerDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "registerDate", $$v)
                          },
                          expression: "form.registerDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "生效日期", prop: "effectiveDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "date",
                          align: "center",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.effectiveDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "effectiveDate", $$v)
                          },
                          expression: "form.effectiveDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "截止时间", prop: "closeDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "220px" },
                        attrs: {
                          type: "date",
                          align: "center",
                          "value-format": "yyyy-MM-dd",
                        },
                        model: {
                          value: _vm.form.closeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "closeDate", $$v)
                          },
                          expression: "form.closeDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "BOI是否", prop: "isBOI" } },
                    [
                      _c("el-switch", {
                        attrs: { "active-text": _vm.form.isBOI ? "是" : "否" },
                        model: {
                          value: _vm.form.isBOI,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isBOI", $$v)
                          },
                          expression: "form.isBOI",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "月结是否", prop: "isMonthEnd" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": _vm.form.isMonthEnd ? "是" : "否",
                        },
                        model: {
                          value: _vm.form.isMonthEnd,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isMonthEnd", $$v)
                          },
                          expression: "form.isMonthEnd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否禁用", prop: "isActived" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": _vm.form.isActived ? "是" : "否",
                        },
                        model: {
                          value: _vm.form.isActived,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isActived", $$v)
                          },
                          expression: "form.isActived",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "是否敏感进口商",
                        prop: "isSensitiveImporter",
                      },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": _vm.form.isSensitiveImporter
                            ? "是"
                            : "否",
                        },
                        model: {
                          value: _vm.form.isSensitiveImporter,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isSensitiveImporter", $$v)
                          },
                          expression: "form.isSensitiveImporter",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "国家", prop: "countryId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { filterable: "", placeholder: "请选择" },
                          on: { change: _vm.handleCountry },
                          model: {
                            value: _vm.form.countryId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "countryId", $$v)
                            },
                            expression: "form.countryId",
                          },
                        },
                        _vm._l(_vm.countryOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "省州", prop: "provinceId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "220px" },
                          attrs: { filterable: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.provinceId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "provinceId", $$v)
                            },
                            expression: "form.provinceId",
                          },
                        },
                        _vm._l(_vm.stateOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "城市", prop: "cityAddress" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请输入" },
                        on: {
                          input: function ($event) {
                            return _vm.onInput("cityAddress")
                          },
                        },
                        model: {
                          value: _vm.form.cityAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cityAddress", $$v)
                          },
                          expression: "form.cityAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮编", prop: "postcode" } },
                    [
                      _c("NumberPoint", {
                        staticStyle: { width: "280px" },
                        attrs: { placeholder: "请输入", decimalPlaces: "0" },
                        model: {
                          value: _vm.form.postcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "postcode", $$v)
                          },
                          expression: "form.postcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 17 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "地址", prop: "address" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入" },
                            on: {
                              input: function ($event) {
                                return _vm.onInput("address")
                              },
                            },
                            model: {
                              value: _vm.form.address,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "address", $$v)
                              },
                              expression: "form.address",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "付款方式", prop: "paymentType" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { filterable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.form.paymentType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "paymentType", $$v)
                                },
                                expression: "form.paymentType",
                              },
                            },
                            _vm._l(_vm.paymentTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注", prop: "remark" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isView,
                      expression: "isView",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "供应商", prop: "supplierIds" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择",
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            "collapse-tags": "",
                          },
                          model: {
                            value: _vm.supplierIds,
                            callback: function ($$v) {
                              _vm.supplierIds = $$v
                            },
                            expression: "supplierIds",
                          },
                        },
                        _vm._l(_vm.supplierOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c("el-switch", {
                    attrs: { "active-text": "F865" },
                    model: {
                      value: _vm.form.isF865,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "isF865", $$v)
                      },
                      expression: "form.isF865",
                    },
                  }),
                  _vm.form.isF865
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "NAICS Code", prop: "naicsId" } },
                        [
                          _c("custom-select", {
                            ref: "customSelect1",
                            attrs: {
                              value: _vm.form.naicsId,
                              width: "1070px",
                              selectItems: _vm.naicsOptions,
                            },
                            model: {
                              value: _vm.form.naicsId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "naicsId", $$v)
                              },
                              expression: "form.naicsId",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isView,
              expression: "!isView",
            },
          ],
          staticClass: "footers flex_c_c",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "debounce-click",
                  rawName: "v-debounce-click",
                  value: { value: _vm.ok, args: ["form"] },
                  expression: "{ value: ok, args: ['form'] }",
                },
              ],
              staticClass: "ok flex_c_c",
            },
            [_vm._v(" 确定 ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }